import React from 'react';
import { Box, HStack, Text, VStack } from 'native-base';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../../../../utils/fonts';
import { COLORS } from '../../../../utils/colors';
import { EventPlanDetailsCards } from './eventPlanDetailsCard';

const FoodMenuCard = ({ menuData }) => {
  if (!menuData || !menuData.menu || menuData.menu.length === 0) {
    return null;
  }

  const getCategoryDot = (category) => {
    const isNonVeg = category?.toLowerCase() === 'non veg';
    
    if (isNonVeg) {
      // Non-veg: Red dot inside border container
      return (
        <Box
          width="24px"
          height="24px"
          borderRadius="4px"
          backgroundColor="#FFE5E5"
          marginRight="4px"
          alignItems="center"
          justifyContent="center"
          style={{
            border: '1px solid #D32F2F40'
          }}
        >
          <Box
            width="8px"
            height="8px"
            borderRadius="full"
            backgroundColor="#D32F2F"
          />
        </Box>
      );
    } else {
      // All other categories: Green dot inside border container
      return (
        <Box
          width="24px"
          height="24px"
          borderRadius="4px"
          backgroundColor="#E8F5E8"
          marginRight="4px"
          alignItems="center"
          justifyContent="center"
          style={{
            border: '1px solid #4CAF5040'
          }}
        >
          <Box
            width="8px"
            height="8px"
            borderRadius="full"
            backgroundColor="#4CAF50"
          />
        </Box>
      );
    }
  };

  const getCategoryTag = (category) => {
    if (!category) return null;
    
    const isNonVeg = category?.toLowerCase() === 'non veg';
    
    // Show tags for all categories
    return (
      <Box
        backgroundColor={isNonVeg ? '#FFE5E5' : '#E8F5E8'}
        fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
        paddingX="8px"
        paddingY="2px"
        borderRadius="4px"
        marginLeft="4px"
        style={{
          border: isNonVeg ? '1px solid #D32F2F40' : '1px solid #4CAF5040'
        }}
      >
        <Text
          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          color={isNonVeg ? '#D32F2F' : '#4CAF50'}
        >
          {category}
        </Text>
      </Box>
    );
  };

  return (
    <Box>
      {menuData.menu.map((menuType, menuIndex) => (
        <Box key={menuIndex} mb={4}>
          <Text
            fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
            color={COLORS.BLACK_COLOR}
            mb={3}
          >
            {menuType?.type}
          </Text>
          
          <EventPlanDetailsCards
            mt='3px'
            body={
              <VStack
                p={5}
                pb={0}
                style={{
                  flexWrap: 'wrap',
                  width: '100%',
                  border: '1px solid rgb(235, 235, 235)',
                  background: 'white',
                  borderRadius: '12px',
                }}
              >
                {menuType.items && menuType.items.map((item, itemIndex) => (
                  <Box
                    key={itemIndex}
                    py={'12px'}
                    px={'16px'}
                    borderRadius={'12px'}
                    bg='#FEF5EE'
                    width={'100%'}
                    mb={3}
                  >
                    <VStack space={2}>
                      <HStack
                        alignItems="center"
                        width="100%"
                      >
                        <Text
                          fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
                          fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                          color={COLORS.BLACK_COLOR}
                          flex={1}
                        >
                          {item?.food}
                        </Text>
                        <HStack alignItems="center" space={1}>
                          {getCategoryDot(item.food_category)}
                          {getCategoryTag(item.food_category)}
                        </HStack>
                      </HStack>
                      
                      {item?.food_type && (
                        <Text
                          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                          color={COLORS.ATTACHMENTS_TEXT_COLOR}
                        >
                          {item?.food_type}
                        </Text>
                      )}
                      
                      {item.food_description && (
                        <Text
                          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                          color={COLORS.ATTACHMENTS_TEXT_COLOR}
                          lineHeight="20px"
                        >
                          {item?.food_description}
                        </Text>
                      )}
                      
                      {(item?.allergen_codes || item?.cuisine_type) && (
                        <HStack alignItems="center" space={3} mt={2} flexWrap="wrap">
                          {item?.allergen_codes && (
                            <HStack alignItems="center" space={2}>
                              <Text
                                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                                color={COLORS.BLACK_COLOR}
                              >
                                Allergen Codes:
                              </Text>
                              <Text
                                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                                fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                                color={COLORS.ATTACHMENTS_TEXT_COLOR}
                              >
                                {item?.allergen_codes}
                              </Text>
                            </HStack>
                          )}
                          
                          {item?.allergen_codes && item?.cuisine_type && (
                            <Box
                              width="1px"
                              height="16px"
                              backgroundColor={COLORS.ATTACHMENTS_TEXT_COLOR}
                              opacity={0.3}
                            />
                          )}
                          
                          {item?.cuisine_type && (
                            <HStack alignItems="center" space={2}>
                              <Text
                                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                                color={COLORS.BLACK_COLOR}
                              >
                                Cuisine Type:
                              </Text>
                              <Text
                                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                                fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                                color={COLORS.ATTACHMENTS_TEXT_COLOR}
                              >
                                {item?.cuisine_type}
                              </Text>
                            </HStack>
                          )}
                        </HStack>
                      )}
                    </VStack>
                  </Box>
                ))}
              </VStack>
            }
          />
        </Box>
      ))}
    </Box>
  );
};

export default FoodMenuCard;
